import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const FilterControls = ({ 
  searchTerm, 
  onSearchChange, 
  statusFilter, 
  onStatusChange,
  industryFilter,
  onIndustryChange,
  leadVolumeFilter,
  onLeadVolumeChange,
  dateRangeStart,
  onDateRangeStartChange,
  dateRangeEnd,
  onDateRangeEndChange,
  onClearFilters,
  resultCount 
}) => {
  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'verified', label: 'Verified' },
    { value: 'pending', label: 'Pending' },
    { value: 'suspended', label: 'Suspended' },
  ];

  const industryOptions = [
    { value: 'all', label: 'All Industries' },
    { value: 'real-estate', label: 'Real Estate' },
    { value: 'financial-services', label: 'Financial Services' },
    { value: 'technology', label: 'Technology' },
    { value: 'consulting', label: 'Consulting' },
    { value: 'other', label: 'Other' },
  ];

  const leadVolumeOptions = [
    { value: 'all', label: 'All Volumes' },
    { value: '0-10', label: '0-10 leads' },
    { value: '11-50', label: '11-50 leads' },
    { value: '51-100', label: '51-100 leads' },
    { value: '100+', label: '100+ leads' },
  ];

  const hasActiveFilters = statusFilter !== 'all' || industryFilter !== 'all' || 
                          leadVolumeFilter !== 'all' || dateRangeStart || dateRangeEnd || searchTerm;

  return (
    <div className="bg-card rounded-lg border border-border elevation-1 p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Filter Partners</h2>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            iconPosition="left"
            onClick={onClearFilters}
          >
            Clear Filters
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
        <div className="lg:col-span-2">
          <Input
            type="search"
            placeholder="Search by company, contact, email, or Salesforce ID..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e?.target?.value)}
          />
        </div>
        <Select
          options={statusOptions}
          value={statusFilter}
          onChange={onStatusChange}
          placeholder="Filter by status"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Select
          options={industryOptions}
          value={industryFilter}
          onChange={onIndustryChange}
          placeholder="Filter by industry"
        />
        <Select
          options={leadVolumeOptions}
          value={leadVolumeFilter}
          onChange={onLeadVolumeChange}
          placeholder="Filter by lead volume"
        />
        <Input
          type="date"
          label="Registration From"
          value={dateRangeStart}
          onChange={(e) => onDateRangeStartChange(e?.target?.value)}
        />
        <Input
          type="date"
          label="Registration To"
          value={dateRangeEnd}
          onChange={(e) => onDateRangeEndChange(e?.target?.value)}
        />
      </div>
      {resultCount !== null && (
        <div className="mt-4 pt-4 border-t border-border">
          <p className="text-sm text-muted-foreground">
            Showing <span className="font-semibold text-foreground">{resultCount}</span> partner{resultCount !== 1 ? 's' : ''}
          </p>
        </div>
      )}
    </div>
  );
};

export default FilterControls;